import React from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { DateTime } from 'luxon'

import './styles.scss'
import settingsActions from 'redux/settings/actions'
import { getStaticImage } from 'utils/statics'
import { getParsedDate } from '../utils'
import { getChannelName } from 'utils/channelsUtils'

const MessageBox = ({ messageId, user, delegation, date, text, channel }) => {
  const dispatch = useDispatch()
  const { push } = useHistory()
  const parsedDate = getParsedDate(date)
  const channelName = getChannelName([channel])

  const handleOnClickMessage = () => {
    const dateInSeconds = DateTime.fromISO(date).toSeconds()
    const newDate = DateTime.fromSeconds(dateInSeconds - 300).toUTC().toString()
    dispatch(settingsActions.set({ dateToSearchMessages: newDate, messageIdToGo: messageId }))
    push({
      pathname: '/dashboard/conversations/users',
      search: `?user_id=${user.id}`
    })
  }

  return (
    <div className='search-results-message-box' onClick={handleOnClickMessage}>
      <div className='search-results-message-box__header'>
        <strong className='search-results-message-box__category'>#{delegation}</strong>
        <span className='search-results-message-box__date'>{parsedDate.date}</span>
        <figure className='search-results-message-box__channel-icon'>
          <img src={getStaticImage(`/channels/orange-brand/${channelName}-icon.svg`)} alt={channelName} />
        </figure>
      </div>
      <div className='search-results-message-box__body'>
        <div className='search-results-message-box__user'>
          <figure className='search-results-message-box__user-avatar'>
            <img
              src={user.picture || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
              alt={user.name}
              onError={({ target }) => target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')}
            />
          </figure>
          <div className='search-results-message-box__user-info'>
            <strong className='search-results-message-box__user-name'>{user.name}</strong>
            <span className='search-results-message-box__time'>{parsedDate.time}</span>
          </div>
        </div>
        <div className='search-results-message-box__message'>
          <p
            className='search-results-message-box__message-text'
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </div>
      </div>
    </div>
  )
}

export default MessageBox
